import React, { useState, useEffect,useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { useAssetContext } from "../../DataContext/AssetContext";
import { useAssetContext } from "../../components/DataContext/AssetContext";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import CardAsset from "../../components/AssetDashboard/CardAssets/CardAsset";
import AssetFilters from "../../components/AssetDashboard/CardAssets/AssetFilters";
import TabSection from "../../components/AssetDashboard/ChartTabs";
import { tabsConfig } from "../../components/AssetDashboard/tabsConfig";
import { useEntitlements } from "../../components/DataContext/EntitlementsContext";
import { SlRefresh } from "react-icons/sl";
import { SlReload } from "react-icons/sl";

const slugify = (label: string) => label.toLowerCase().replace(/\s+/g, "-");

const AssetDashboard: React.FC = () => {
  const { assetSlug, tab } = useParams<{ tab: string; assetSlug: string }>();
  const navigate = useNavigate();
  const { entitlements } = useEntitlements();
  const {
    resetFilters,
    setSelectedDateRange,
    setSelectedFrequency,
    setStartDate,
    setEndDate,
  } = useAssetContext();
  const userEmail = localStorage.getItem("userEmail");

  const [assetNotFound, setAssetNotFound] = useState(false);
  const [assetName, setAssetName] = useState("");
  

  const [refreshCounter, setRefreshCounter] = useState(0);
  const [refreshCounterr, setRefreshCounterr] = useState(0);
  const shouldResetFiltersRef = useRef(true);
  const previousTabLabelRef = useRef<string>();
  const { setActiveTabLabel } = useAssetContext();


  // const handleRefresh = () => {
  //   sessionStorage.removeItem("assetDashboardApiCache");
  //   setRefreshCounter((prev) => prev + 1);
  // };

  const entitledPaths = entitlements.map((e) => e.po_path.toLowerCase().trim());
//   let entitledPaths = entitlements.map((e) =>
//   e.po_path.toLowerCase().trim()
// );

// ✅ DEV ONLY override for localhost demo
// if (process.env.NODE_ENV === "development") {
//   entitledPaths.push("/asset-dashboard/asset-revenue");
// }
  const visibleTabs = tabsConfig.tabs.filter((t) =>
    entitledPaths.includes(`/asset-dashboard/${slugify(t.label)}`)
  );

  const handleRefresh = () => {
    sessionStorage.removeItem("assetDashboardApiCache");
    shouldResetFiltersRef.current = true; 
    setRefreshCounter(prev => prev + 1);
  };
  
  const handleForceApiRefresh = () => {
    shouldResetFiltersRef.current = false;
    setRefreshCounterr(prev => prev + 1);
  };
  

 
  const visibleTabIndex = visibleTabs.findIndex((t) => slugify(t.label) === tab);
  const defaultIndex = visibleTabIndex !== -1 ? visibleTabIndex : 0;
  const activeTab = defaultIndex;
  const activeTabLabel = visibleTabs[defaultIndex]?.label || "";

  useEffect(() => {
  setActiveTabLabel(activeTabLabel);
}, [activeTabLabel]);

  useEffect(() => {
    if (previousTabLabelRef.current === "Asset Revenue" && activeTabLabel !== "Asset Revenue") {
      setSelectedDateRange("yesterday");
      setSelectedFrequency("hour");
      setStartDate(null);
      setEndDate(null);
    }

    previousTabLabelRef.current = activeTabLabel;
  }, [activeTabLabel, setEndDate, setSelectedDateRange, setSelectedFrequency, setStartDate]);

  useEffect(() => {
    if (visibleTabIndex === -1 && visibleTabs.length > 0) {
      navigate(`/asset-dashboard/${slugify(visibleTabs[0].label)}/${assetSlug}`, {
        replace: true,
      });
    }
  }, [visibleTabIndex, visibleTabs, assetSlug, navigate,refreshCounter]);


  useEffect(() => {
    if (assetNotFound) {
      const timer = setTimeout(() => {
        navigate("/landing");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [assetNotFound, navigate,refreshCounter]);

  const handleAssetNotFound = (slugOrName: string) => {
    setAssetNotFound(true);
    setAssetName(slugOrName);
  };

  useEffect(() => {
    if (visibleTabIndex === -1 && visibleTabs.length > 0 && assetSlug) {
      navigate(`/asset-dashboard/${slugify(visibleTabs[0].label)}/${assetSlug}`, {
        replace: true,
      });
    }
  }, [visibleTabIndex, visibleTabs, assetSlug, navigate, refreshCounter]);
  
  // useEffect(() => {
  //   resetFilters();
  // }, [refreshCounter]);
useEffect(() => {
  if (shouldResetFiltersRef.current) {
    resetFilters();
    shouldResetFiltersRef.current = false;
  }
}, [refreshCounter]);

  
  return (
    <div className="flex flex-col min-h-screen font-poppins">
      <div className="flex-grow">
        <Header />
       
        {/* <div className="flex justify-end pr-10 pt-4"> */}
        <div className="relative bg-[#F7F7FF]">

  <button
    onClick={handleRefresh}
    className="absolute right-10 top-4 p-2 text-gray-400 rounded-full hover:text-[#FF3B30] z-10"
    title="ReSet Page"
  >
            <SlReload className="w-6 h-6" />
          </button>
          <button
            onClick={handleForceApiRefresh}
            className="absolute right-20 top-4 p-2 text-gray-400 rounded-full hover:text-[#FF3B30] z-10"
            title="Refresh Page"
          >
            <SlRefresh className="w-6 h-6" />
          </button>

</div>
        <main className="bg-[#F7F7FF]">
          {assetNotFound ? (
            <div className="flex justify-center items-center h-[50vh] text-center">
              <div className="text-red-600 text-xl font-medium">
                User {userEmail} does not have access to this asset {assetName}
              </div>
            </div>
          ) : (
            <>
              <CardAsset
                onAssetNotFound={handleAssetNotFound}
                activeTabLabel={activeTabLabel}
                onAssetFoundName={(name) => setAssetName(name)}
                assetSlug={assetSlug}
                refreshCounter={refreshCounter} 
                refreshCounterr={refreshCounterr} 
              />

              <AssetFilters
                activeTabLabel={activeTabLabel}
                assetSlug={assetSlug}
                refreshCounter={refreshCounter}
              />

              <TabSection
                key={`${tab || "default"}-${assetSlug || ""}`}
                tabsConfig={{ tabs: visibleTabs }}
                activeTab={activeTab}
                assetSlug={assetSlug}
                refreshCounter={refreshCounter}
              />
            </>
          )}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default AssetDashboard;
